import configurationStore from '../../store/backoffice/configuration'

export default {
  install: function (Vue,) {
    Vue.prototype.$is = function (index) {
      return index.split('|').includes(this.type)
    }

    Vue.prototype.$isModuleEnabled = function (item) {
      const module = configurationStore.state.modules.modules_enabled.value.find((module) => {
        return item === module
      })

      return item === module
    }

    Vue.prototype.$isNot = function (index) {
      return !(this.$is(index))
    }

    Vue.directive('click-outside', {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his childrens
          if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/lib/plugins/attributes.js